import { useQuery } from "@apollo/client";
import { GET_ALL_PERSONS_EXTENDED } from "../api/get-all-persons-extended";
import { MetaFilter } from "@/shared/filters-by-meta";
import { PersonSearchInput } from "gql/graphql";
import { usePagination } from "@/shared/navigation/pagination";

export function usePersonsExtended() {
  const personFilter = MetaFilter.useFilter<PersonSearchInput>()?.filter;
  const { getTablePaginationConfig, pageRequest: pageableRequest } =
    usePagination();

  const { data, previousData, loading } = useQuery(GET_ALL_PERSONS_EXTENDED, {
    variables: {
      personFilter,
      pageableRequest,
    },
  });

  const persons =
    data?.findPersons?.content ?? previousData?.findPersons?.content ?? [];

  const total =
    data?.findPersons?.total ?? previousData?.findPersons?.total ?? 0;

  return {
    persons,
    loading,
    pagination: getTablePaginationConfig(total),
  };
}
